import _ from 'lodash';
import update from 'immutability-helper';

import {
    CLEAR_FILTER,
    ADD_FILTER,
    REMOVE_FILTER,
    TOGGLE_FILTER,
    SET_FILTER_TEXT,
    SET_FILTER
} from '../actions/filter';

const initialState = {};

function filter(state = initialState, action) {
    switch (action.type) {
        case CLEAR_FILTER:
            return initialState;

        case ADD_FILTER:
            return update(state, {
                [action.name]: {
                    $apply: values => {
                        return _(values)
                            .push(action.value)
                            .uniq()
                            .value();
                    }
                }
            });

        case REMOVE_FILTER:
            return update(state, {
                [action.name]: {
                    $apply: values => {
                        return _(values)
                            .filter(v => v !== action.value)
                            .value();
                    }
                }
            });

        case TOGGLE_FILTER:
            let ret;
            if (!state[action.name]) {
                ret = update(state, {
                    [action.name]: { $set: [action.value] }
                });
            } else {
                if (
                    _(state[action.name]).find(
                        f => f.slug === action.value.slug
                    )
                ) {
                    ret = update(state, {
                        [action.name]: {
                            $apply: values => {
                                return _(values)
                                    .filter(v => v.slug !== action.value.slug)
                                    .value();
                            }
                        }
                    });
                } else {
                    ret = update(state, {
                        [action.name]: {
                            $apply: values => {
                                return _(values)
                                    .push(action.value)
                                    .uniq()
                                    .value();
                            }
                        }
                    });
                }
            }

            return ret;

        case SET_FILTER_TEXT:
            return update(state, { text: { $set: action.text } });

        case SET_FILTER:
            return action.filter;

        default:
            return state;
    }
}

export default filter;



// WEBPACK FOOTER //
// ./wp-content/themes/gwy/assets/scripts/source/vpm/post-grid/reducers/filter.js